// extracted by mini-css-extract-plugin
export default {"mainPane":"TeamMembers_mainPane__EBoAY","itemDetails":"TeamMembers_itemDetails__Hax+0"};